import { call, put, select, StrictEffect, takeLatest } from 'redux-saga/effects';
import timeTracking from 'services/timeTracking';
import { Timer } from 'services/timeTracking/types';

import {
  addActiveLogData,
  getActiveLogs,
  getActiveLogsSilent,
  removeActiveLogData,
  setActiveLogsActiveData,
  setActiveLogsData,
  setActiveLogsError,
  setActiveLogsLoading,
  updateActiveLogData,
} from './activeLogs-slice';

/**
 * worker saga
 *
 * V2: The open timers (running + paused) of the authenticated user come from /timers/current.
 * The endpoint already scopes by the user itself — no filtering by UUID is needed.
 */
export function* getActiveLogsSagaListener(): any {
  try {
    yield put(setActiveLogsLoading());

    const timers: Timer[] = yield call(timeTracking.fetchCurrentTimers);

    yield put(setActiveLogsData(timers));
  } catch (e) {
    yield put(setActiveLogsError(e));
  }
}

export function* getActiveLogsSilentSagaListener(): any {
  try {
    const timers: Timer[] = yield call(timeTracking.fetchCurrentTimers);

    yield put(setActiveLogsData(timers));
  } catch (e) {
    yield put(setActiveLogsError(e));
  }
}

export function* updatedActiveLogsSagaListener(): any {
  const activeLogs = yield select((store) => store.activeLogs.data);

  const active = activeLogs?.find((item: any) => item.status === 'running') ?? null;

  yield put(setActiveLogsActiveData(active));
}

/**
 * watcher saga
 */
function* activeLogsSaga(): Generator<StrictEffect> {
  yield takeLatest(getActiveLogs.type, getActiveLogsSagaListener);
  yield takeLatest(getActiveLogsSilent.type, getActiveLogsSilentSagaListener);
  yield takeLatest(setActiveLogsData.type, updatedActiveLogsSagaListener);
  yield takeLatest(addActiveLogData.type, updatedActiveLogsSagaListener);
  yield takeLatest(updateActiveLogData.type, updatedActiveLogsSagaListener);
  yield takeLatest(removeActiveLogData.type, updatedActiveLogsSagaListener);
}

export default activeLogsSaga;
